import axios from "axios";
import i18n from "../../i18n";

const actions = {
  bulkDeleteBetriebsanweisungen(context, ids) {
    return axios
      .post("betriebsanweisung/bulk-delete", { ids })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  bulkMoveBetriebsanweisungen(context, { ids, instructionCategory }) {
    return axios
      .post("betriebsanweisung/bulk-move", { ids, instructionCategory })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  getBetriebsanweisungen(context, { instructionCategoryId } = {}) {
    return axios
      .get("betriebsanweisung", {
        params: {
          ...(instructionCategoryId
            ? { instructionCategory: instructionCategoryId }
            : {}),
          populate: "operatingInstructionLabel",
        },
      })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  getSingleBetriebsanweisung(context, id) {
    return axios
      .get("betriebsanweisung/" + id, {
        params: { populate: "operatingInstructionLabel" },
      })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  async copyBetriebsanweisung(context, id) {
    const source = await axios
      .get("betriebsanweisung/" + id)
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
    if (!source) return null;

    const payload = {
      type: source.type,
      title: i18n.t("betriebsanweisung.copyTitle", { name: source.title }),
      number: source.number,
      revisionStand: source.revisionStand,
      company: source.company,
      workplace: source.workplace,
      date: source.date,
      reviewDate: source.reviewDate,
      responsiblePerson: source.responsiblePerson,
      instructionCategory:
        source.instructionCategory?._id || source.instructionCategory,
      operatingInstructionLabel:
        source.operatingInstructionLabel?._id ||
        source.operatingInstructionLabel ||
        null,
      sections: (source.sections || []).map((s) => ({
        key: s.key,
        title: s.title,
        bullets: [...(s.bullets || [])],
        symbols: [...(s.symbols || [])],
      })),
    };

    return axios
      .post("betriebsanweisung", payload)
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("betriebsanweisung.copiedMessage", { name: r.data.title })
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  approveBetriebsanweisung(context, { id }) {
    return axios
      .post("betriebsanweisung/" + id + "/approve")
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.proof.proofedMessage")
        );
        return r.data;
      })
      .catch((e) => {
        context.dispatch("triggerError", e);
        throw e;
      });
  },

  rejectBetriebsanweisung(context, { id, reason }) {
    return axios
      .post("betriebsanweisung/" + id + "/reject", { reason })
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.proof.rejectedMessage")
        );
        return r.data;
      })
      .catch((e) => {
        context.dispatch("triggerError", e);
        throw e;
      });
  },

  getBetriebsanweisungVersions(context, id) {
    return axios
      .get("betriebsanweisung/" + id + "/versions")
      .then((r) => r.data)
      .catch((e) => {
        context.dispatch("triggerError", e);
        return { versions: [], currentVersion: 0, canProof: false };
      });
  },

  createBetriebsanweisungImport(context, value) {
    return axios
      .post("betriebsanweisung/batch", value)
      .then((r) => {
        let message = i18n.t("betriebsanweisung.import.resultMessage", {
          success: r.data.successCount,
          failed: r.data.failedCount,
        });

        const unknown = r.data.unknownSymbols || [];
        if (unknown.length) {
          message +=
            " " +
            i18n.t("betriebsanweisung.import.unknownSymbols", {
              count: unknown.length,
              symbols: unknown.join(", "),
            });
        }

        context.commit("CREATE_SNACKBAR", message);
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  createBetriebsanweisung(context, value) {
    return axios
      .post("betriebsanweisung", value)
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("betriebsanweisung.createdMessage", { name: r.data.title })
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  updateBetriebsanweisung(context, value) {
    return axios
      .put("betriebsanweisung/" + value.id, value)
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("betriebsanweisung.updatedMessage", { name: r.data.title })
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  getBetriebsanweisungPdf(context, id) {
    return axios
      .get("betriebsanweisung/" + id + "/pdf")
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  deleteBetriebsanweisung(context, val) {
    return axios
      .delete("betriebsanweisung/" + val.id)
      .then((res) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("betriebsanweisung.deletedMessage")
        );
        return res;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },
};

export default actions;
